module.exports = __webpack_public_path__ + "static/media/cross_blurred.81af08eb.jpg";